import React from 'react';
import { useSelector } from 'react-redux';

import Chip from '@features/filter/Chip';
import Search from '@features/filter/Common/Search';
import Sort from '@features/filter/Common/Sort';
import TeamChip from '@features/filter/Common/TeamChip';

import { convertNumberToUSFormat } from '@utils/Util';

const TopFilter = ({ statusType, completedTab, toggleFilter }) => {
	const costingCountStore = useSelector((store) => store.costingStore);
	const listOfCostingStore = useSelector((store) => store.filterResponseStore);
	const activeTabInfo = useSelector((store) => store.costingStore.activeTabInfo);
	const getFilterPageType = () => {
		if (completedTab === 'DESIGN_STUDIO' || statusType === 'REQUESTED') return 'INITIAL_COSTING_LIST';
		return 'COSTING_LIST';
	};

	const getQuouteCountInfo = () => {
		switch (activeTabInfo?.activeTabName) {
			case 'DESIGN_STUDIO_PENDING':
			case 'DESIGN_STUDIO_IN_REVIEW':
			case 'DESIGN_STUDIO_COMPLETED':
				return getStatusForDesignStudio();
			case 'COLLECTION_VIEW_PENDING':
			case 'COLLECTION_VIEW_COMPLETED':
				return getStatusForFashionDesigner();
			default:
				return getStatusForBuyerDesign();
		}
	};

	const getStatusForBuyerDesign = () => (
		<ul className="common-list-component">
			<li>
				<span className="semibold-14">{listOfCostingStore?.totalElements}</span> Request
			</li>
			<li>
				<span className="semibold-14">{costingCountStore?.quoteCount?.noOfDesign}</span> Design
			</li>
			<li>
				<span className="semibold-14">
					{costingCountStore?.quoteCount?.quotedCount}/{costingCountStore?.quoteCount?.noOfVariant}
				</span>{' '}
				Quoted
			</li>
			<li>
				<span className="semibold-14">
					${convertNumberToUSFormat(costingCountStore?.quoteCount?.totalPrice, true) || 0}
				</span>
			</li>
			<li>
				<span className="semibold-14">
					{convertNumberToUSFormat(costingCountStore?.quoteCount?.totalQuantity, true) || 0}
				</span>{' '}
				pcs
			</li>
		</ul>
	);

	const getStatusForDesignStudio = () => (
		<ul className="common-list-component">
			<li>
				<span className="semibold-14">{listOfCostingStore?.totalElements}</span> Items
			</li>
		</ul>
	);

	const getStatusForFashionDesigner = () => (
		<ul className="common-list-component">
			<li>
				<span className="semibold-14">{listOfCostingStore?.totalElements}</span> Request
			</li>

			<li>
				<span className="semibold-14">
					{costingCountStore?.quoteCount?.quotedCount}/{costingCountStore?.quoteCount?.noOfDesign}
				</span>{' '}
				Quoted
			</li>
		</ul>
	);

	return (
		<div className="filter-container-top pt-2 pb-2 bg-gray d-block">
			<div className="d-flex align-items-center justify-content-between">
				<div className="filters">
					<div className="filter-toggle" onClick={() => toggleFilter()}>
						<img src={process.env.PUBLIC_URL + '/icons/filter24.svg'} alt="filter" />
						<span>Filter</span>
					</div>

					<div className="samples-summary">{getQuouteCountInfo()}</div>

					<TeamChip />
				</div>

				<div className="filter-actions sample-dashboard-filter">
					<div className={`filter-actions sample-list-filter-actions`}>
						<Search placeholder="Ref number or title" identifier="search" />
						<div className="transparent-sort">
							<Sort
								title={'COSTING_LIST'}
								removedLastModified={true}
								sortKeyWord={getFilterPageType() === 'COSTING_LIST' ? 'id' : 'collectionId'}
							/>
						</div>
					</div>
				</div>
			</div>

			<Chip />
		</div>
	);
};

export default TopFilter;
